import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { QBox, QCenter, QIcon } from '@qualio/ui-components';
import { useLocalisedFormatDateTime } from '../../../utils/datetimeUtils';

type StepStartTimeConstraintInfoProps = {
  startTimeConstraint: number;
  lastUpdated: number | null;
};

const StepStartTimeConstraintInfo = ({ startTimeConstraint, lastUpdated }: StepStartTimeConstraintInfoProps) => {
  const { t } = useTranslation();
  const formatDateTime = useLocalisedFormatDateTime();
  const now = DateTime.now().toSeconds();
  const startDate = lastUpdated || now;
  if (now < startDate + startTimeConstraint) {
    return (
      <QCenter bg="yellow.100" m={4} p={3} borderRadius="base" data-cy="step-start-time-constraint-alert">
        <QIcon iconName="Info" color="yellow.500" />
        <QBox ml={2}>
          {t('tasks.messages.cannotSendForApprovalUntil')} {formatDateTime(startDate + startTimeConstraint)}
        </QBox>
      </QCenter>
    );
  }
  return null;
};

export default StepStartTimeConstraintInfo;
